import { Expose } from 'class-transformer';
import { BasicData } from '../basic/BasicData';

export class Drone {
    // export class Drone extends BasicData {
    static readonly ModelFeatureAttribute = {
        CLASS_NAME: 'Drones',
    };

    @Expose()
    id: string = '';

    @Expose()
    title: '';

    @Expose()
    copterVersion: string = '';

    @Expose()
    targetComponent: '';

    @Expose()
    state: string = '';

    @Expose()
    targetSystem: '';

    @Expose()
    modifiedAt: '';
}
